import { render, staticRenderFns } from "./AutomationsOption.vue?vue&type=template&id=19ac7bc2&scoped=true&"
import script from "./AutomationsOption.vue?vue&type=script&lang=js&"
export * from "./AutomationsOption.vue?vue&type=script&lang=js&"
import style0 from "./AutomationsOption.vue?vue&type=style&index=0&id=19ac7bc2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ac7bc2",
  null
  
)

export default component.exports